"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkScheduleSlotByIdApiResponseSchema = void 0;
const zod_1 = require("zod");
const get_list_1 = require("./get-list");
const work_schedule_slot_1 = require("./work-schedule-slot");
exports.getWorkScheduleSlotByIdApiResponseSchema = zod_1.z.object({
    data: get_list_1.getWorkScheduleSlotItemApiSchema,
    included: zod_1.z
        .array(zod_1.z.union([
        work_schedule_slot_1.workScheduleSlotDoctorAttendingApiSchema,
        work_schedule_slot_1.workScheduleSlotSequenceApiSchema,
    ]))
        .optional()
        .default([]),
});
